const selectors = {
    loginForm: '[js-login]'
}

const placeholders = {
    email: 'Votre email',
    password: 'Votre mot de passe'
}

const loginForm = document.querySelector(selectors.loginForm);

if (loginForm) {
    const email = loginForm.querySelector('input[type="text"]');
    const password = loginForm.querySelector('input[type="password"]');

    email.setAttribute('placeholder', placeholders.email);
    password.setAttribute('placeholder', placeholders.password);
}
